import {
  FetchLeaderboardStatistics,
  FetchLeaderboardStatisticsVariables,
} from "_graphql/queries/__generated__/FetchLeaderboardStatistics";

import { fetchLeaderboardStats } from "_graphql/visal/queries/leaderboard";
import { useQuery } from "@apollo/client";

export const useLeaderboardStatistics = ({
  brokerId,
  year = new Date().getFullYear(),
}: {
  brokerId: string;
  year?: number;
}) => {
  const { data, loading, error, refetch } = useQuery<
    FetchLeaderboardStatistics,
    FetchLeaderboardStatisticsVariables
  >(fetchLeaderboardStats, {
    variables: {
      brokerId,
      year,
    },
    fetchPolicy: "network-only",
    skip: !brokerId,
  });

  const totalCashAccumulated =
    data?.fetchLeaderboardStatistics?.badges?.reduce((total, badge) => {
      const badgeTotal =
        badge?.insurers?.reduce(
          (sum, insurer) =>
            sum + (insurer?.total_redeemable_cash_equivalent || 0),
          0
        ) || 0;
      return total + badgeTotal;
    }, 0) || 0;

  return {
    leaderboard: data?.fetchLeaderboardStatistics || null,
    totalCashAccumulated,
    loading,
    error,
    refetch,
  };
};
